import { render, staticRenderFns } from "./ModalImages.vue?vue&type=template&id=2bade705&scoped=true"
import script from "./ModalImages.vue?vue&type=script&lang=js"
export * from "./ModalImages.vue?vue&type=script&lang=js"
import style0 from "./ModalImages.vue?vue&type=style&index=0&id=2bade705&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bade705",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bade705')) {
      api.createRecord('2bade705', component.options)
    } else {
      api.reload('2bade705', component.options)
    }
    module.hot.accept("./ModalImages.vue?vue&type=template&id=2bade705&scoped=true", function () {
      api.rerender('2bade705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalImages.vue"
export default component.exports